/**
 * @file PhotoGroup related fragments.
 */

import gql from 'graphql-tag';

import { PhotoThumbnails } from './album';

export const AlbumPhotoGroupBasicDetails = gql`
  fragment AlbumPhotoGroupBasicDetails on AlbumPhotoGroup {
    id
    name
    created_at
    updated_at
    last_uploaded: photos(include_unprocessed: true, slice: { limit: 1 }) {
      records {
        id
        ...PhotoThumbnails
      }
    }
    album {
      id
    }
    start_date
    end_date
    display_order
  }
  ${PhotoThumbnails}
`;

export const AlbumPhotoGroupBasics = gql`
  query albumPhotoGroupBasics($id: RecordID!) {
    albumPhotoGroup(id: $id) {
      ...AlbumPhotoGroupBasicDetails
    }
  }
  ${AlbumPhotoGroupBasicDetails}
`;
